/* Moments Etched v15.4.7.14 — final customer-facing neck-label caption cleanup */
(() => {
  const INTERNAL_NECK_PLACEMENT = 'Custom Neck Label';

  const getNeckMode = (root) => String(
    root?.dataset?.meNeckLabelMode ||
    root?.querySelector?.('[data-me-neck-label-choice]:checked')?.value ||
    'original'
  );

  const displayLabel = (root) => {
    const mode = getNeckMode(root);
    if (mode === 'me-branding') return 'Moments Etched Label';
    if (mode === 'custom') return 'Your Brand Label';
    return 'Neck Label';
  };

  const activePlacement = (root) => String(
    root?.querySelector?.('[data-me-preview-placement-label]')?.textContent || ''
  ).trim();

  const sync = (root) => {
    if (!root || activePlacement(root) !== INTERNAL_NECK_PLACEMENT) return;

    const label = displayLabel(root);

    /* data-me-preview-guide-name is customer-facing only. Core preview logic may
       reset it to the internal placement key whenever the preview rerenders, so
       restore the selected branding label after each render. */
    root.querySelectorAll('[data-me-preview-guide-name]').forEach((node) => {
      if (node.textContent !== label) node.textContent = label;
      node.setAttribute('aria-label', label);
    });
  };

  const syncAll = () => document.querySelectorAll('[data-me-designer]').forEach(sync);

  const bind = (root) => {
    if (!root) return;

    const guideName = root.querySelector('[data-me-preview-guide-name]');
    if (guideName && guideName.dataset.meV154714Bound !== 'true') {
      guideName.dataset.meV154714Bound = 'true';
      new MutationObserver(() => {
        if (activePlacement(root) === INTERNAL_NECK_PLACEMENT) {
          requestAnimationFrame(() => sync(root));
        }
      }).observe(guideName, { childList: true, characterData: true, subtree: true });
    }

    if (root.dataset.meV154714RootBound !== 'true') {
      root.dataset.meV154714RootBound = 'true';
      root.addEventListener('change', (event) => {
        if (event.target?.matches?.('[data-me-neck-label-choice]')) {
          requestAnimationFrame(() => requestAnimationFrame(() => sync(root)));
        }
      });
    }

    requestAnimationFrame(() => sync(root));
  };

  const init = () => document.querySelectorAll('[data-me-designer]').forEach(bind);
  const deferSync = () => requestAnimationFrame(() => requestAnimationFrame(syncAll));

  window.addEventListener('me:preview-placement', deferSync);
  window.addEventListener('me:neck-label-updated', deferSync);
  window.addEventListener('me:placements-updated', deferSync);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
